/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину контейнера товара
 */
export const PRODUCT_CONTAINER_WIDTH_INTENTION = 16;

/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину контента в кнопке товара
 */
export const PRODUCT_CONTENT_WIDTH_INTENTION = 34;

/**
 * Величина, на которую надо сдвигать каждое медиа в кнопке товара
 */
export const MEDIA_ITEM_OFFSET = 20;

/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину текста в кнопке товара
 */
export const PRODUCT_TEXT_CONTAINER_WIDTH_INTENTION = 50;
